// React
import React from 'react';
import PropTypes from 'prop-types';
// Material components
import { withStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grow from '@mui/material/Grow';
import Zoom from '@mui/material/Zoom';
import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/Button';
import { Link } from 'react-router-dom';

class LinkIcon extends React.PureComponent {

    state = {
        mouseOver: false
    };

    static propTypes = {
        classes: PropTypes.object,
        icon: PropTypes.object,
        time: PropTypes.number
    };

    handleMouseEnter = () => {
        this.setState({
            mouseOver: true
        });
    };

    handleMouseLeave = () => {
        this.setState({
            mouseOver: false
        });
    };

    renderMouseOverIcon() {
        const { classes, icon } = this.props;
        return (
            <Zoom
                in={true}>
                <Link to={icon.path} className={classes.tabButtonContainer}>
                    <IconButton>
                        <Icon className={classes.NavigateIcon}>
                            input
                        </Icon>
                    </IconButton>
                </Link>
            </Zoom>
        );
    }

    renderMouseNotOverIcon() {
        const { classes, icon } = this.props;

        return (
            <div className={classes.tabIconContainer}>
                {icon.dashboardIcon}
            </div>
        );
    }

    render() {
        const { classes, icon, time } = this.props;
        const color = '#2AB4AD';

        return (
            <Grow
                in={true}
                style={{ transformOrigin: '0 0 0' }}
                {...({ timeout: 1000 * time / 2 })}
                onMouseEnter={this.handleMouseEnter}
                onMouseLeave={this.handleMouseLeave}
            >
                <Paper className={classes.tab}
                    elevation={2}
                    style={{ backgroundColor: color }}>
                    <div className={classes.tabTitleContainer}>
                        <Typography
                            variant='h6'
                            gutterBottom
                            className={classes.tabTitle}>
                            {icon.sidebarName}
                        </Typography>
                    </div>
                    {this.state.mouseOver === true ? this.renderMouseOverIcon() : this.renderMouseNotOverIcon()}
                </Paper>
            </Grow>
        );
    }
}

const styles = theme => ({
    tab: {
        display: 'flex',
        width: '30%',
        margin: '5px',
        flexWrap: 'wrap',
    },
    tabTitleContainer: {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        marginTop: theme.spacing(2.5),
    },
    tabTitle: {
        color: 'white',
        fontWeight: 'bold',
        textAlign: 'center'
    },
    tabIconContainer: {
        display: 'flex',
        width: '100%',
        height: 70,
        justifyContent: 'center',
        marginBottom: theme.spacing(2.5),
    },
    tabButtonContainer: {
        display: 'flex',
        width: '100%',
        height: 70,
        justifyContent: 'center',
        marginBottom: theme.spacing(2.5),
        textDecoration: 'none',
    },
    NavigateIcon: {
        display: 'flex',
        color: 'white',
        fontSize: 40,
    },
    '@media (max-width: 600px)': {
        tab: {
            display: 'flex',
            width: '100%',
            marginTop: theme.spacing(1.25),
            marginBottom: theme.spacing(1.25),
            flexWrap: 'wrap',
        },
    }
});

export default withStyles(styles)(LinkIcon);
